import { render, staticRenderFns } from "./IamPolicies.vue?vue&type=template&id=dabf91a8&scoped=true&"
import script from "./IamPolicies.vue?vue&type=script&lang=js&"
export * from "./IamPolicies.vue?vue&type=script&lang=js&"
import style0 from "./IamPolicies.vue?vue&type=style&index=0&id=dabf91a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabf91a8",
  null
  
)

export default component.exports